import { combineEpics, ofType } from "redux-observable";
import { filter } from "rxjs/operators";
import { guard } from "../guards/guard";
import { TypeActionScene } from "./actionScenes";
import { checkHasAssetDependencies } from "./checkHasAssetDependencies";
import { pathSwapScene } from "./pathSwapScene";
import { pathWaitTillDependenciesLoad } from "./pathWaitTillDependenciesLoad";
var createEpicScene = function (scene) { return function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionScene.RequestSwap), filter(function (action) { return action.sceneId === scene.sceneId; }), guard(state$, deps, pathSwapScene(scene))([
        checkHasAssetDependencies(scene)(pathWaitTillDependenciesLoad(scene, action$)),
    ]));
}; };
export var createEpicScenes = function (scenes) {
    var sceneEpics = Object.keys(scenes).map(function (key) { return createEpicScene(scenes[key]); });
    return combineEpics.apply(combineEpics, sceneEpics);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/createEpicScenes.ts
// module id = 2126
// module chunks = 3